// import dailyReport from "./dailyReport";
import tripReport from './tripReport';
import overSpeedReport from './overSpeedReport';
import positionReport from './positionReport';
import fuelReport from './fuelReport';
import fuelChartData from './fuelChart';
import ptoReport from './ptoReport';
import idlingReport from './idlingReport';
import geofenceReport from './geofenceReport';
import summaryReport from './summaryReport';
import temperatureReport from './temperatureReport';
import fuelUsedRateSumReport from './fuelUsedRateSumReport';
import tripA4Report from './tripA4Report';
import enterExitGeofenceReport from './enterExitGeofenceReport';
import newIdlingReport from './idlingReportNew';
import i18n from '@/i18n';
import getSafetyAlarmReport from './safetyAlarmReport';

export default {
  // dailyReport,
  tripReport,
  overSpeedReport,
  positionReport,
  fuelChartData,
  fuelReport,
  ptoReport,
  idlingReport,
  geofenceReport,
  summaryReport,
  temperatureReport,
  fuelUsedRateSumReport,
  tripA4Report,
  enterExitGeofenceReport,
  newIdlingReport,
  getSafetyAlarmReport
};

export const reportTypesEnum = Object.freeze({
  S01GeofenceCurrent: 'geofence_current_report',
  S02FuelRate: 'fuel_rate_report',
  S03FleetSummary: 'fleet_summary_report',
  S04TempWithChart: 'temperature_with_chart',
  S05TempPdf: 'report_temperature_pdf',
  N01Daily: 'daily',
  N02Trip: 'trip',
  N03Trip24hr: 'trip24hr',
  N04TripOver4hour: 'tripOver4hour',
  N05Fuel: 'fuel',
  N06Temperature: 'temperature',
  N07Overspeed: 'overspeed',
  N08Position: 'position',
  N09FuelChart: 'fuelChart',
  N10TempChart: 'tempChart',
  N11Pto: 'pto',
  N12Idling: 'idling',
  N13IdlingSummary: 'idlingSummary',
  N14Geofences: 'geofences',
  N15Summary: 'summary',
  N16FuelUsedRateSummary: 'fuelUsedRateSummary',
  N17IdlingOpenPTO: 'idlingOpenPTO',
  N18TripA4: 'tripA4',
  N19SpeedChart: 'speedChart',
  N20VehicleUsageSummary: 'vehicleUsageSummary',
  N21EnterExitGeofenceReport: 'enterExitGeofenceReport',
  N22SummaryByDay: 'summaryByDay',
  N23FuelStdRate: 'fuelStdRate',
  N24TripOver8hour: 'tripOver8hour',
  N25AllDevice: 'allDevice',
  N26KPIDriver: 'kpiDriver',
  N27SafetyAlarm: 'safetyAlarm'
});

export const getSpecialReportTypeList = () => [
  {
    no: 1,
    label: i18n.t('reports.reportTypes.geofenceCurrent'),
    value: reportTypesEnum.S01GeofenceCurrent,
  },
  {
    no: 2,
    label: i18n.t('reports.reportTypes.fuelRate'),
    value: reportTypesEnum.S02FuelRate,
  },
  {
    no: 3,
    label: i18n.t('reports.reportTypes.fleetSummary'),
    value: reportTypesEnum.S03FleetSummary,
  },
  {
    no: 4,
    label: i18n.t('reports.reportTypes.tempWithChart'),
    value: reportTypesEnum.S04TempWithChart,
  },
  {
    no: 5,
    label: i18n.t('reports.reportTypes.tempPdf'),
    value: reportTypesEnum.S05TempPdf,
  },
];

export const getNormalReportTypeList = () => [
  { no: 1, label: i18n.t('reports.reportTypes.daily'), value: reportTypesEnum.N01Daily },
  { no: 2, label: i18n.t('reports.reportTypes.trip'), value: reportTypesEnum.N02Trip },
  { no: 6, label: i18n.t('reports.reportTypes.temperature'), value: reportTypesEnum.N06Temperature },
  { no: 8, label: i18n.t('reports.reportTypes.position'), value: reportTypesEnum.N08Position },
  {
    no: 20,
    label: i18n.t('reports.reportTypes.vehicleUsageSummary'),
    value: reportTypesEnum.N20VehicleUsageSummary,
  },
];

// Keep backward compatibility with existing code that uses these as static arrays
export const specialReportTypeList = [
  { no: 1, value: reportTypesEnum.S01GeofenceCurrent, labelKey: 'geofenceCurrent' },
  { no: 2, value: reportTypesEnum.S02FuelRate, labelKey: 'fuelRate' },
  { no: 3, value: reportTypesEnum.S03FleetSummary, labelKey: 'fleetSummary' },
  { no: 4, value: reportTypesEnum.S04TempWithChart, labelKey: 'tempWithChart' },
  { no: 5, value: reportTypesEnum.S05TempPdf, labelKey: 'tempPdf' },
];

export const normalReportTypeList = [
  { no: 1, value: reportTypesEnum.N01Daily, labelKey: 'daily' },
  { no: 2, value: reportTypesEnum.N02Trip, labelKey: 'trip' },
  { no: 6, value: reportTypesEnum.N06Temperature, labelKey: 'temperature' },
  { no: 8, value: reportTypesEnum.N08Position, labelKey: 'position' },
  { no: 20, value: reportTypesEnum.N20VehicleUsageSummary, labelKey: 'vehicleUsageSummary' },
];

export function convertReportLabel(reportType) {
  const reportTypeToKey = {
    [reportTypesEnum.S01GeofenceCurrent]: 'geofenceCurrent',
    [reportTypesEnum.S02FuelRate]: 'fuelRate',
    [reportTypesEnum.S03FleetSummary]: 'fleetSummary',
    [reportTypesEnum.S04TempWithChart]: 'tempWithChart',
    [reportTypesEnum.S05TempPdf]: 'tempPdf',
    [reportTypesEnum.N01Daily]: 'daily',
    [reportTypesEnum.N02Trip]: 'trip',
    [reportTypesEnum.N03Trip24hr]: 'trip24hr',
    [reportTypesEnum.N04TripOver4hour]: 'tripOver4hour',
    [reportTypesEnum.N05Fuel]: 'fuel',
    [reportTypesEnum.N06Temperature]: 'temperature',
    [reportTypesEnum.N07Overspeed]: 'overspeed',
    [reportTypesEnum.N08Position]: 'position',
    [reportTypesEnum.N09FuelChart]: 'fuelChart',
    [reportTypesEnum.N10TempChart]: 'tempChart',
    [reportTypesEnum.N11Pto]: 'pto',
    [reportTypesEnum.N12Idling]: 'idling',
    [reportTypesEnum.N13IdlingSummary]: 'idlingSummary',
    [reportTypesEnum.N14Geofences]: 'geofences',
    [reportTypesEnum.N15Summary]: 'summary',
    [reportTypesEnum.N16FuelUsedRateSummary]: 'fuelUsedRateSummary',
    [reportTypesEnum.N17IdlingOpenPTO]: 'idlingOpenPTO',
    [reportTypesEnum.N18TripA4]: 'tripA4',
    [reportTypesEnum.N19SpeedChart]: 'speedChart',
    [reportTypesEnum.N20VehicleUsageSummary]: 'vehicleUsageSummary',
    [reportTypesEnum.N21EnterExitGeofenceReport]: 'enterExitGeofence',
    [reportTypesEnum.N22SummaryByDay]: 'summaryByDay',
    [reportTypesEnum.N23FuelStdRate]: 'fuelStdRate',
    [reportTypesEnum.N24TripOver8hour]: 'tripOver8hour',
    [reportTypesEnum.N25AllDevice]: 'allDevice',
    [reportTypesEnum.N26KPIDriver]: 'kpiDriver',
    [reportTypesEnum.N27SafetyAlarm]: 'safetyAlarm',
  };

  const key = reportTypeToKey[reportType];
  return key ? i18n.t(`reports.reportTypes.${key}`) : '-';
}

export const getReportId = (reportType) => {
  const reportIdMap = {
    [reportTypesEnum.S01GeofenceCurrent]: 'S01',
    [reportTypesEnum.S02FuelRate]: 'S02',
    [reportTypesEnum.S03FleetSummary]: 'S03',
    [reportTypesEnum.S04TempWithChart]: 'S04',
    [reportTypesEnum.S05TempPdf]: 'S05',
    [reportTypesEnum.N01Daily]: 'N01',
    [reportTypesEnum.N02Trip]: 'N02',
    [reportTypesEnum.N03Trip24hr]: 'N03',
    [reportTypesEnum.N04TripOver4hour]: 'N04',
    [reportTypesEnum.N05Fuel]: 'N05',
    [reportTypesEnum.N06Temperature]: 'N06',
    [reportTypesEnum.N07Overspeed]: 'N07',
    [reportTypesEnum.N08Position]: 'N08',
    [reportTypesEnum.N09FuelChart]: 'N09',
    [reportTypesEnum.N10TempChart]: 'N10',
    [reportTypesEnum.N11Pto]: 'N11',
    [reportTypesEnum.N12Idling]: 'N12',
    [reportTypesEnum.N13IdlingSummary]: 'N13',
    [reportTypesEnum.N14Geofences]: 'N14',
    [reportTypesEnum.N15Summary]: 'N15',
    [reportTypesEnum.N16FuelUsedRateSummary]: 'N16',
    [reportTypesEnum.N17IdlingOpenPTO]: 'N17',
    [reportTypesEnum.N18TripA4]: 'N18',
    [reportTypesEnum.N19SpeedChart]: 'N19',
    [reportTypesEnum.N20VehicleUsageSummary]: 'N20',
    [reportTypesEnum.N21EnterExitGeofenceReport]: 'N21',
    [reportTypesEnum.N22SummaryByDay]: 'N22',
    [reportTypesEnum.N23FuelStdRate]: 'N23',
    [reportTypesEnum.N24TripOver8hour]: 'N24',
    [reportTypesEnum.N25AllDevice]: 'N25',
    [reportTypesEnum.N26KPIDriver]: 'N26',
    [reportTypesEnum.N27SafetyAlarm]: 'N27',
  };

  return reportIdMap[reportType] || 'N01';
};
